import React from "react";
import { Layers, ShieldCheck, MapPin, KeyRound, Globe2, LineChart } from "lucide-react";
import { useLang } from "../../context/LanguageContext";
import { SectionHeading } from "../motion/SectionHeading";
import { Stagger, StaggerItem } from "../motion/Reveal";

const ICONS = [Layers, ShieldCheck, MapPin, KeyRound, Globe2, LineChart];
// Asymmetric bento spans (Tetris)
const SPANS = [
  "md:col-span-7", "md:col-span-5",
  "md:col-span-5", "md:col-span-7",
  "md:col-span-7", "md:col-span-5",
];

export const WhyUs = () => {
  const { t } = useLang();
  return (
    <section className="py-10 sm:py-14 bg-lightgray" data-testid="why-us-section">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <SectionHeading overline={t.why.overline} title={t.why.title} />
        <Stagger className="grid grid-cols-2 md:grid-cols-12 gap-0 mt-6 sm:mt-10" stagger={0.08}>
          {t.why.items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <StaggerItem key={i} className={SPANS[i]}>
                <div
                  className="group h-full bg-white p-4 sm:p-8 border border-border transition-all duration-500 hover:border-gold/40 hover:shadow-[0_20px_50px_rgba(31,94,59,0.08)]"
                  data-testid={`why-card-${i}`}
                >
                  <div className="flex items-start justify-between mb-4 sm:mb-8">
                    <span className="w-9 h-9 sm:w-12 sm:h-12 rounded-xl bg-green/8 flex items-center justify-center group-hover:bg-green group-hover:scale-110 transition-all duration-500">
                      <Icon className="w-4 h-4 sm:w-5 sm:h-5 text-green-light group-hover:text-white transition-colors duration-500" />
                    </span>
                    <span className="font-display text-2xl sm:text-4xl text-gold/25 group-hover:text-gold/50 transition-colors">0{i + 1}</span>
                  </div>
                  <h3 className="font-display text-base sm:text-xl text-charcoal mb-1.5 sm:mb-2.5 leading-tight">{item.t}</h3>
                  <p className="text-charcoal/55 text-[11px] sm:text-sm leading-snug sm:leading-relaxed">{item.d}</p>
                </div>
              </StaggerItem>
            );
          })}
        </Stagger>
      </div>
    </section>
  );
};
